import React from 'react'
import Skeleton, { SkeletonProps } from 'react-loading-skeleton'

import { cn } from '@/lib/utils'

type Props = SkeletonProps & {
  length: number
}

const SkeletonText: React.FC<Props> = ({
  length,
  style,
  className,
  ...props
}) => {
  return (
    <Skeleton
      style={{ ...style, width: `${length}ch` }}
      className={cn('max-w-full', className)}
      {...props}
    />
  )
}

export default SkeletonText
